/* ==========================================================================
   focuss-animations.js
   Animación de entrada al hacer scroll para las secciones "FL ·".

   NOTA: el archivo original no venía dentro de la plantilla. Esto es una
   reconstrucción: observa los elementos con la clase .fl-reveal y les agrega
   .fl-in cuando entran en pantalla. Los estilos están en focuss-landing.css.

   Si el navegador no soporta IntersectionObserver, todo se muestra normal.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__flAnimations) return;
  window.__flAnimations = true;

  var root = document.documentElement;
  var supported = 'IntersectionObserver' in window;

  // Solo escondemos los elementos si de verdad vamos a poder revelarlos.
  if (supported) root.classList.add('fl-anim-ready');

  var observer = supported
    ? new IntersectionObserver(onIntersect, {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      })
    : null;

  function onIntersect(entries) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('fl-in');
      observer.unobserve(entry.target);
    }
  }

  function reveal(el) {
    el.classList.add('fl-in');
  }

  function scan(scope) {
    var container = scope || document;
    var items = container.querySelectorAll('.fl-reveal:not(.fl-in)');

    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (el.__flWatched) continue;
      el.__flWatched = true;

      if (!observer) {
        reveal(el);
        continue;
      }

      // Lo que ya está visible al cargar se revela de inmediato,
      // así no queda contenido en blanco arriba de la página.
      var box = el.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) {
        reveal(el);
      } else {
        observer.observe(el);
      }
    }
  }

  function start() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Editor de temas de Shopify: al agregar o recargar una sección.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var items = event.target.querySelectorAll('.fl-reveal');
    for (var i = 0; i < items.length; i++) reveal(items[i]);
  });

  // Red de seguridad: si algo quedó sin revelar, se muestra igual.
  window.setTimeout(function () {
    var stuck = document.querySelectorAll('.fl-reveal:not(.fl-in)');
    for (var i = 0; i < stuck.length; i++) {
      var box = stuck[i].getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) reveal(stuck[i]);
    }
  }, 2500);
})();
